export enum FilterItemType {
  ID_VALUE = 'ID_VALUE',
  RANGE = 'RANGE',
}
